import styled from "styled-components";

interface Props {
  content: string;
  setClose: (val: boolean) => void;
}

export default function ErrorModal({ content, setClose }: Props) {
  const handleClose = () => {
    setClose(false);
  };

  return (
    <Wrapper>
      <div className="success-modal-overlay">
        <div className="modal">
          <div className="content">
            <div className="top">
              <div className="succes">
                <svg color="#ff0000" xmlns="http://www.w3.org/2000/svg" width={120} height={120} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-x"><circle cx={12} cy={12} r={10} /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
              </div>
              <button className="close-btn" onClick={handleClose}>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAcSSURBVHgBVVbbi5VVFF9rX76jdiFyuhCFdKEQsxxLx0xomC4PRZRREUSUFCVF9dBDD/0TPdiVgm5U1EMUFb1EZogMqJViGXnLzPGpUsGZc/Zl9Vtrf051mDPfPvvbe11+a63fWkz4fPzJN5Nd161zTGeFLgTnXHSeY/Be153H07ffERvBeRdD8O091t7O46nvvQv629ahrSHjFH5/MBjE58P7H309Rcxrcs2Q6RLnKuTUDEeVhEgKM/478pRrIYr4g2U5FxK89vhSIPswseS21Jvt6e3MGRCycXZ2eDzUUpaWXFOFwIob5DJJdRwgBSsognZWCwrBI6qlQiiLh9J/P9KUMsMGwWnGRqWmXERPqn3eu42hcGUuPnvIrK5QKU61CFd4Wp2dr4J1YPmfAtNQ53cglAU/Q3SUuUhoMMFMtvPtel0U8gj+hcqwnTofYRU8UevYsYzgaYCnuBMqsKmnFXgTZWrMMQVe4B0Lp94OQO8EmAWLjiAehDhyKCIj9R1+SZYiDh6b9RDOwUlRT/He4FUci8xjWQGOCtb3zWeFUWyNUwwFsKuKAkQhtLDUnLNTL1RDqYijZ7PQObUMy4CYVtZYBmHOoVqs1DnnPLmiqQMlWcOXKei90IzQbU04snjpQYaHVRJSjjRJkmOOGQ4hlkhmwRkczJRhkK+aqUgXjoYESwtMmocZiJDnwibcXOYeeNNrEMDoUmpSVwqUDiA44UhEjEYlkQbeh0ixFCmnxWbsA9rSwwY3OaXaAqVhbOCzOkXmnljEWw4Br5xxXIKEGNValA2U6yGLGwTBng8/enttGo3OfPSJZ79rniikVVy2OpMP3ntjKQwLGzY8tg9VyxoypKnFXsJ/qqdqCFBWgC6nPMwl5YQkSdjAsyRgl7LUXEou3++cvunNV19cp4jYV2sXZ197+cXxL7/4bPXJ4yccDiaYn4BHQrZlyMoqQ2XqWewkP3Xr+kvVaqCL+FRu2CNE7AwOTfnlV19/eGbmd7/rxx03zxw9IiuuW31I3Xzz9U1rt23dMrF23eT2J558Zqdd1WRSCcZDShpiNNCCjoKavGX9JUztmNEZIHFKZvi6lmUsWIyvWHMASl1T+ofs3Dl9yfbpbetWr7lx2+Mbn5m2XG0q7JITyyHba6zQjPE33Xz3xc5JYyBE2lWNi6gOlHJtrOKapddC6TFTul2VLrlu1cSWRx9/eiuLRRU24grrGpa6fq/hRD3haFmUFESJGadGiXwXqY6QOGAfUT5Cbeo+dUodWq11nuIQIdxGVgVjNVI2IVa2QoBAniWot04ruy8L+DI1ddcFVBsW6qS1Bumrx+iCG43A5HffeunOX37effvSZdd+dcGFFx0weGcQ0/HVh5yfpzkTYnddD2htcqGE/cTk3WMVBKi1A0tZdaGHkcGJpxNNJeb339m0fv+ve++64splnz/8yFNfjq9cdeDo0SNud0ukumJ81UHqaVTjhY/64WzR9BrGftWNty1Gg6SOldnYXqgK2AJKK+beh++9ct9vB/fde+nlV33y4CNPfcqtomn8+on9UGaJ9Pdff566evn4EddnJi5r+knfSSy+mhf+hrV3nIPmpvUNjH2LLFs/M6W63vvTD5ctHjt/1wMPPfkZ+hduuZYFVfialRP7j80cAR2Hsmz5ysMNf9end48l90HU53MvbFoCR6JbgCuOIjgzInHw9dGLCx36gR/EwDpCsNMRAiMFRx9xBkHAEBF03IBxGCmw30aOYE/2GFgwhugpG08wpgyTgLPB2HNIsgUgacCunA0yJRxD70IghomiiYzauRsxpkQ1BFGyLwp9B6JOzPO9UIkbyGkjRxNpXR//Qz4xl8PZCyii9+h0MUT70RZCNot4bf6k4weQNOXe1b6TI+4g/BJVCU5lmImQsJYXSklLMViPCtZ/dakQhhOc02D2JHbOAj6nUEWL0I5UZAclyQYqrftsDXfEbhClzVbY44AKKhiBsvisgp21NsVJyaPlbDPQ2mOuHBIPU+d1PQevFxAQjt0cGi2PqAyCdBiouoVGVTbFpeRsMovzYmAdEPWwY6StK+iwUk0pRi3ORgOu9XR0Jb9kbDmff/YiHvAiOTlCKOBNgRzMqSQpcQWL+KpQVZ0ZtKC5MxbmFhjd0Aqzylb+bQnMrQXMK2MlIS31iYnFac8emH7ecYoyYJrFELnQ0zANZBCd9ZFyuqmrb0iQWcFJlJkftI5uY5XWHCxNvnmvYbE9y4A2d3HJc37z5s1y//2TcnDuXDrzBMw9Y0AD9Q5QgjcpKjfCbPQ1XHfGjZgIdErTrgIfqvYU81Dlc0/ajcu5zXXWs51ywQ5TrkrHl2ygsbE5mu0Qh5NDnq1DWlh1REQmssYEZayoQja6K9BlmxpVpI6IvS4MdW0c7mmxwep4CA+nH7hn6tt/AMKCCrRdsmCFAAAAAElFTkSuQmCC"
                  alt="close"
                />
              </button>
            </div>
            <div className="title-text">{content}</div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .modal {
    display: block;
  }

  .success-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(58, 65, 85, 0.25);
    width: 100vw;
    height: 100vh;
    z-index: 999999999999999;

    .modal {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%);
      background: #ffffff;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.12);
      border-radius: 6px;
      width: 53.5rem;
      height: 310px;
      overflow: unset !important;
      padding: 3.6rem;

      .content {
        display: block;
      }

      .top {
        display: flex;

        justify-content: center;
        margin-bottom: 20px;
        position: relative;

        .succes {
          margin-bottom: 20px;
        }

        .close-btn {
          width: 28px;
          height: 28px;
          position: absolute;
          right: 0;
          top: 0;
          left: auto;
          border-radius: 3px;
          background: transparent !important;
          border: none;
        }
      }

      .title-text {
        font-family: "Nunito";
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        color: #1b1c1f;
        text-align: center;
        margin-bottom: 24px;
      }

      p {
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 150%;
        color: #444444;
        padding: 0 0 36px;
        text-align: center;
      }

      button {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 20px;
        height: 60px;
        color: #ffffff;
        background: #1b1c1f;
        border-radius: 6px;
        width: 100%;
      }
    }

    @media screen and (max-width: 767.9px) {
      .modal {
        width: 90vw !important;

        .succes {
          svg {
            width: 100px;
            height: 100px;
          }
        }

        .title-text {
          font-size: 20px !important;
          margin-bottom: 16px !important;
        }

        button {
          font-size: 16px !important;
          height: 50px !important;
        }
      }
    }
  }
`;
